<app-nav [navItems]="navItems" />
<div class="static">
  <h1>Refund policy</h1>
  <p><span>Effective Date:</span>21.08.2024</p>
  <p>
    At videosense.net, we strive to provide high-quality products and services
    that meet our users' needs. However, we understand that there may be
    circumstances where a refund is necessary. This Refund Policy outlines the
    conditions under which refunds may be issued.
  </p>
  <p>
    <strong>1. Eligibility for Refunds</strong>
  </p>
  <p>Refunds are only available under the following circumstances:</p>
  <p><strong>1.1 Technical Issues:</strong></p>
  <p>
    If you are unable to download a purchased image due to technical problems
    with our platform, and our support team is unable to resolve the issue.
  </p>
  <p>
    <strong>1.2 Duplicate Purchases:</strong>
  </p>
  <p>
    If the same item is accidentally purchased more than once, a refund for the
    duplicate transaction will be issued upon request.
  </p>
  <p><strong>1.3 Incorrect Charges:</strong></p>
  <p>
    If you believe you were charged incorrectly (e.g., incorrect pricing or
    unauthorized transaction), contact our support team for resolution.
  </p>
  <p><strong>2. Non-Refundable Situations</strong></p>
  <p><strong>2.1 Change of Mind:</strong></p>
  <p>
    Refunds are not issued for change-of-mind purchases or if the image is no
    longer needed.
  </p>
  <p><strong>2.2 Downloaded Products:</strong></p>
  <p>
    Once a file is successfully downloaded, it is considered delivered, and no
    refund will be provided unless the file is defective or corrupted.
  </p>
  <p><strong>2.3 Usage Violations:</strong></p>
  <p>
    Refunds will not be issued if the content has been used in violation of our
    <a routerLink="/terms-of-use">Terms of Use</a>.
  </p>
  <p><strong>2.4 Free Content:</strong></p>
  <p>Refunds are not applicable to free downloads.</p>
  <p><strong>3. Refund Request Process</strong></p>
  <p>To request a refund:</p>
  <ul>
    <li>
      <strong>Step 1:</strong> Contact our support team at
      <a
        [href]="'mailto:' + environment.support_email"
        [textContent]="environment.support_email"
      ></a>
      with your order details (order ID, transaction receipt, and description of
      the issue).
    </li>
    <li>
      <strong>Step 2:</strong> Provide supporting evidence, such as screenshots
      or error messages, if applicable.
    </li>
    <li>
      <strong>Step 3:</strong> Allow up to 5 business days for our team to
      review your request and respond with a resolution.
    </li>
  </ul>
  <p><strong>4. Refund Timeline</strong></p>
  <p>If your refund request is approved:</p>
  <ul>
    <li>Refunds will be processed within 7-10 business days</li>
    <li>
      The refunded amount will be credited to your original payment method.
      Processing times may vary depending on your bank or payment provider.
    </li>
  </ul>
  @if (false) {
    <p><strong>5. Subscriptions</strong></p>
    <p><strong>5.1 Cancellation of Subscriptions:</strong></p>
    <ul>
      <li>
        You may cancel your subscription at any time, but cancellations are not
        eligible for refunds.
      </li>
      <li>
        Access to subscription benefits will remain active until the end of the
        current billing cycle.
      </li>
    </ul>
    <p><strong>5.2 Refunds for Subscriptions:</strong></p>
    <ul>
      <li>
        Refunds for subscriptions will only be issued in cases of duplicate
        charges or technical issues that prevent you from accessing the service.
      </li>
    </ul>
    <p><strong>6. Contact Information</strong></p>
  } @else {
    <p><strong>5. Contact Information</strong></p>
  }
  <p>
    If you have any questions or concerns about our Refund Policy, please
    contact us:
  </p>
  <p>
    <strong>VIDEO SENSE LTD</strong><br />
    82a James Carter Road, Mildenhall,<br />
    Bury St. Edmunds, England, IP28 7DE<br />
    <span>Email:</span>
    <a
      [href]="'mailto:' + environment.support_email"
      [textContent]="environment.support_email"
    ></a>
  </p>
  <p>
    We are committed to providing a seamless experience and resolving any issues
    promptly. Thank you for choosing videosense.net!
  </p>
</div>
